import 'jquery-validation';
import Utils from '../../util/utils';
const CommentForm = {

    _jForm: $('.jsCommentForm'),
    email: '',
    init() {
        this.initValidations();
    },
    initValidations() {
        const me = this;
        if (this._jForm.length > 0) {
            var config = Utils.getValidationConfig({
                ignore: [],
                rules: {
                    your_name: {
                        required: true,
                        minlength: 2,
                    },
                    your_email: {
                        required: true,
                        customemail: true,
                    },

                    your_comment: {
                        required: true,
                        minlength: 10,
                    },
                },
                messages: {
                    your_name: {
                        required: 'Please provide your name',
                        minlength: 'Please provide your complete Name',
                    },
                    your_email: {
                        required: 'Please provide your e-mail address',
                        customemail: 'Please provide a valid e-mail address',
                    },
                    your_comment: {
                        required: 'Please provide your comment',
                        minlength: 'Please write at least 10 characters',
                    },
                },
                submitHandler: function() {

                    me.onFormSubmit();

                },
            });
            this._jForm.validate(config);
        }
    },
    
}
export default CommentForm;



// WEBPACK FOOTER //
// ./scripts/modules/forms/comment_form.js